import { Box, Typography } from '@mui/material';
import React, { Component, ErrorInfo, ReactNode } from 'react';
import ReportRoundedIcon from '@mui/icons-material/ReportRounded';

interface ErrorBoundaryProps {
  children: ReactNode;
  fallback?: ReactNode; // Optional custom fallback UI
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  public state: ErrorBoundaryState = {
    hasError: false,
  };

  // This static method is called after an error has been thrown by a descendant component.
  // It receives the error as a parameter and should return a value to update state.
  public static getDerivedStateFromError(_: Error): ErrorBoundaryState {
    return { hasError: true };
  }

  // This method is called after an error has been thrown.
  // It receives the error and an object with componentStack information.
  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // You can log the error to an error reporting service here
    console.error('Uncaught error:', error, errorInfo);
  }

  public render(): ReactNode {
    if (this.state.hasError) {
      // Render custom fallback UI if provided, otherwise a default message
      return (
        <Box 
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
          }}
        >
          <ReportRoundedIcon sx={{ fontSize: 100, color: 'error.main', textShadow: '0 0 10px 0 rgba(0, 0, 0, 0.1)' }} />
          <Typography variant="h6" sx={{ color: localStorage.getItem('theme') === 'light' ? '#000' : '#fff' }}>{this.props.fallback || 'Sorry.. there was an error. Please contact the website administrator.'}</Typography>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;